import { Routes, Route } from "react-router-dom";

import AuthGate from "./components/AuthGate";
import ImpersonationBanner from "./components/ImpersonationBanner";
import RootResolver from "./components/RootResolver";
import StaffGate from "./components/StaffGate";
import ChooseWorkspace from "./pages/ChooseWorkspace";
import CustomerDashboard from "./pages/CustomerDashboard";
import ForgotPassword from "./pages/ForgotPassword";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import SetPassword from "./pages/SetPassword";
import WidgetGallery from "./pages/WidgetGallery";
import AdminAudit from "./pages/admin/AdminAudit";
import AdminHelpDesk from "./pages/admin/AdminHelpDesk";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminPlaceholder from "./pages/admin/AdminPlaceholder";
import AdminRuns from "./pages/admin/AdminRuns";
import AdminShell from "./pages/admin/AdminShell";
import CustomerCreate from "./pages/admin/CustomerCreate";
import CustomerDetail from "./pages/admin/CustomerDetail";
import CustomerIndex from "./pages/admin/CustomerIndex";
import UsageOverview from "./pages/admin/UsageOverview";

export default function App() {
  return (
    <>
      {/* MER-197: pinned above every route so impersonating staff
          always have a one-click path back to the staff view, no
          matter which page the impersonation walked them onto. */}
      <ImpersonationBanner />
      <Routes>
        {/* MER-515: "/" resolves an authed user to their dashboard (or
            /admin for staff); anonymous/unprovisioned visitors get
            ComingSoon. It must never be the placeholder unconditionally. */}
        <Route path="/" element={<RootResolver />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* MER-519: invited / recovery users land here (directly for recovery,
            via RootResolver for invite) to establish a reusable password. */}
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/widget-gallery" element={<WidgetGallery />} />
        {/* MER-532: the multi-membership interstitial. A literal path, so it
            MUST precede the /:slug/* catch-all (which would otherwise match
            "choose-workspace" as a customer slug). Gated by AuthGate. */}
        <Route
          path="/choose-workspace"
          element={
            <AuthGate>
              <ChooseWorkspace />
            </AuthGate>
          }
        />
        {/* MER-193: /admin/* MUST come before /:slug/* (a catch-all that
            would otherwise match "admin" as a customer slug). */}
        <Route
          path="/admin"
          element={
            <StaffGate>
              <AdminShell />
            </StaffGate>
          }
        >
          <Route index element={<AdminOverview />} />
          <Route path="customers" element={<CustomerIndex />} />
          {/* MER-487: static "new" before the :slug matcher so the
              create form never resolves as a customer named "new". */}
          <Route path="customers/new" element={<CustomerCreate />} />
          <Route path="customers/:slug" element={<CustomerDetail />} />
          <Route path="usage" element={<UsageOverview />} />
          <Route path="runs" element={<AdminRuns />} />
          <Route path="audit" element={<AdminAudit />} />
          <Route path="help-desk" element={<AdminHelpDesk />} />
          <Route path="activity" element={<AdminPlaceholder title="Activity" />} />
        </Route>
        <Route path="/:slug/*" element={<CustomerDashboard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}
